/**
 * 操作权限编码集合
 */
export const permissions = {
    // 数据字典管理
    manageLookup: 'ilookup$Service$baseSetting$manageLookup',
}
